import { classNames } from '@ember-decorators/component';
import Super from 'ember-simplepractice/components/shared/full-flyout/footer';
import styles from './footer.module.scss';

@classNames(styles.component)
export default class SharedFullFlyoutFooter extends Super {}
